import { useEffect, useRef } from 'react';
import { Box, Link, Avatar, Text, useResponsive } from '@bitrise/bitkit';

import { SimplePublicApiApp } from '@/models/App';

type AppListItemProps = SimplePublicApiApp & {
  shouldFocus?: boolean;
};

const AppListItem = ({ slug, title, avatarUrl, owner: { name }, shouldFocus }: AppListItemProps): JSX.Element => {
  const ref = useRef<HTMLDivElement & HTMLAnchorElement>(null);
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (shouldFocus) {
      ref.current?.focus();
    } else {
      ref.current?.blur();
    }
  }, [shouldFocus]);

  return (
    <Link
      display="flex"
      className="AppListItem"
      href={`/app/${slug}`}
      paddingY="12"
      paddingX={[20, 12]}
      gap={[12, 8]}
      ref={ref}
      alignItems="center"
      _focus={{
        backgroundColor: 'neutral.95',
        boxShadow: 'none',
      }}
      _hover={{
        backgroundColor: 'neutral.95',
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <Avatar name={title} src={avatarUrl} size={isMobile ? '48' : '32'} variant="project" />
      <Box flexGrow={1} minWidth="0" overflow="hidden">
        <Text textColor="purple.10" size={['3', '2']} fontWeight={['normal', 'bold']} hasEllipsis>
          {title}
        </Text>
        <Text textColor="neutral.40" size="2" hasEllipsis>
          {name}
        </Text>
      </Box>
    </Link>
  );
};

export default AppListItem;
